import './css.js';

async function init() {

    await import('../../assets/unify/plugins/back-to-top.js');
    await import('../../assets/unify/plugins/owl-carousel/owl-carousel/owl.carousel.js');
    let text = await import('../../public/locales/'+locale+'/hotel.json');
    const moment = await import('moment');
    const login = await import('../../assets/custom/js/user/login.js');
    const OwlCarousel = await import(/* webpackChunkName: "owlCarousel" */ '../../assets/unify/js/plugins/owl-carousel.js');
    let parsley = await import('parsleyjs');

    //對使用者輸入的折價券內容進行檢查
    $('#discount-code-text').attr({
        'data-parsley-required': true,
        'data-parsley-pattern': '[A-Za-z0-9]+',
        'data-parsley-pattern-message': '僅可英文數字組合'
    });

    let validator = parsley.$element.find('#discount-code-form').parsley({
        errorsWrapper: '<div></div>',
        errorTemplate: '<span class="color-red" style="font-size: 10pt; color: #e74c3c;"></span>',
        errorsContainer: function (field) {
            return field.$element.closest('div').find('div.error-message');
        }
    });

    $('#discount-code-form-submit').bind('click', function(event){
        validator.validate();
        if (validator.isValid()) {
            $('#discount-code-form').submit();
        }
    });

    //在折價券列表中，顯示隱藏的文字內容
    $('.readmore').click(function (event) {
        var that$ = $(this);
        that$.closest('div.text-content').find('div.texthide').removeClass('texthide').addClass('showmore').end().find('div.overtext').remove();
        that$.remove();
    });

    $(document).ready(function() {
        OwlCarousel.initOwlCarousel();
    });

    /**套裝資料*/
    //判斷套裝內容是否要打開或折疊
    let moreListPanels$ = $('.panel-collapse');
    moreListPanels$.on('shown.bs.collapse', function () {
        let toggleButton = $('div.morelist[href="#' + this.id + '"]');
        if (typeof toggleButton.get(0).scrollIntoView === 'function') {
            toggleButton.get(0).scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
        toggleButton.trigger('changeMoreListText');
    });
    moreListPanels$.on('hidden.bs.collapse', function () {
        let toggleButton = $('div.morelist[href="#' + this.id + '"]');
        toggleButton.trigger('changeMoreListText');
    });

    //打開或折疊套裝內容
    $('.morelist').on('changeMoreListText', function () {
        let collapse = $(this).attr('href');
        let collapse$ = $(collapse);
        let isOpen = collapse$.hasClass('in');

        if (isOpen === true) {
            $(this).find('.show-promotion-list').hide();
            $(this).find('.hidden-promotion-list').show();
        } else {
            $(this).find('.hidden-promotion-list').hide();
            $(this).find('.show-promotion-list').show();
        }
    });

    $(function () {
        function fetchInventory(cb) {
            var that = this;
            that.isLoading = true;
            that.checkInDate = '';
            $.ajax(urlPrefix + '/discount/promotionInventory/' + promotionNo, {
                type: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    'start-date': that.startDay.format('YYYY-MM-DD'),
                    'end-date': that.endDay.format('YYYY-MM-DD'),
                    'room-qty': that.roomQty,
                    'nights': that.nights,
                    'is-channel': that.isChannel,
                    'discount': discountNo
                },
                dataType: 'json',
                success: function(res) {
                    if (true === res.status) {
                        if (true === res.waiting) {
                            that.waiting_on = res.waiting;
                        }
                        var row = that.calendarRow;
                        var inventory = [];
                        var inventoryWeek;
                        for (var i = 0; i <= row; i++) {
                            inventoryWeek = [];
                            for (var j = (7*i); j < (7*(i+1)); j++) {
                                if(j < that.calendar.firstDateDay) {
                                    inventoryWeek.push({
                                        current: false
                                    });
                                } else if (j - that.calendar.firstDateDay >= that.calendar.endDate) {
                                    inventoryWeek.push({
                                        current: false
                                    });
                                } else {
                                    inventoryWeek.push({
                                        date: moment(res.inventory[j - that.calendar.firstDateDay].date),
                                        price: res.inventory[j - that.calendar.firstDateDay].price,
                                        qty: res.inventory[j - that.calendar.firstDateDay].qty,
                                        available: res.inventory[j - that.calendar.firstDateDay].available,
                                        applicable: res.inventory[j - that.calendar.firstDateDay].applicable,
                                        isAfter: moment(res.inventory[j - that.calendar.firstDateDay].date).isSameOrAfter(moment().format('YYYY-MM-DD'), 'day'),
                                        current: true,
                                        discountPrice:res.inventory[j - that.calendar.firstDateDay].discountPrice,
                                        discountExpired:res.inventory[j - that.calendar.firstDateDay].discountExpired
                                    });
                                }
                            }
                            inventory.push(inventoryWeek);
                        }
                        that.inventory = inventory;
                    } else {
                        alert(res.message);
                        cb();
                    }
                    that.isLoading = false;
                }
            });
        }

        if (document.getElementById('vue-discount-promotion') !== null) {
            let today = moment();
            let firstDay = ((Date.parse(startDay)).valueOf() > (Date.parse(discountStartDay)).valueOf()) ? moment(startDay) : moment(discountStartDay);
            let calendarInitDate = today.isBefore(moment(firstDay))? moment(firstDay) : today;

            let vm = new Vue({
                el: '#vue-discount-promotion',
                data: {
                    nights: nights,
                    isChannel: isChannel,
                    roomQty: 1,
                    calendar: {
                        today: today,
                        year: calendarInitDate.year(),
                        month: calendarInitDate.month() + 1,
                        firstDateDay: calendarInitDate.startOf('month').day(),
                        endDate: calendarInitDate.endOf('month').date()
                    },
                    waiting_on: false,
                    inventory: [],
                    checkInDate: '',
                    isWaiting: 0,
                    isLoading: false,
                    nextLoading: false
                },
                created: function () {
                    // 先抓取第一個月份的庫存
                    fetchInventory.call(this);
                },
                computed: {
                    startDay: function() {
                        var calendarStart = ((Date.parse(startDay)).valueOf() > (Date.parse(discountStartDay)).valueOf()) ? moment(startDay) : moment(discountStartDay);
                        if (calendarStart.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')){
                            return calendarStart;
                        } else {
                            return moment([this.calendar.year, this.calendar.month - 1]).startOf('month');
                        }
                    },
                    endDay: function() {
                        var calendarEnd = moment(endDay);
                        if (calendarEnd.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')){
                            return calendarEnd;
                        } else {
                            return moment([this.calendar.year, this.calendar.month - 1]).endOf('month');
                        }
                    },
                    calendarRow: function() {
                        return Math.ceil((this.calendar.endDate + this.calendar.firstDateDay) / 7) - 1;
                    },
                    currentMonth: function() {
                        return this.calendar.today.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month');
                    },
                    checkInDateSend: function() {
                        if (this.checkInDate instanceof moment) {
                            return this.checkInDate.format('YYYY-MM-DD');
                        }
                        return '';
                    },
                    checkNextMonth: function() {
                        var right = (this.calendar.month == 12)
                            ? String(this.calendar.year + 1) + "-01-01"
                            : String(this.calendar.year) + "-" + String(this.calendar.month + 1) +"-01" ;
                        return ((Date.parse(right)).valueOf() > (Date.parse(discountEndDay)).valueOf()) ? false : true;
                    },
                    checkLeftMonth: function() {
                        switch(this.calendar.month) {
                            case 1:
                                var left = String(this.calendar.year - 1) + "-12-31";
                                break;
                            case 2:case 4:case 6:case 8:case 9:
                                var left = String(this.calendar.year) + "-0" + String(this.calendar.month - 1) +"-31";
                                break;
                            case 3:
                                var left = (this.calendar.year % 4 == 0)
                                    ? String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-29"
                                    : String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-28";
                                break;
                            case 5:case 7:case 10:
                                var left = String(this.calendar.year) + "-0" + String(this.calendar.month - 1) +"-30";
                                break;
                            case 11:
                                var left = String(this.calendar.year) + "-" + String(this.calendar.month - 1) +"-31";
                                break;
                            case 12:
                                var left = String(this.calendar.year) + "-" + String(this.calendar.month - 1) +"-30";
                                break;
                        }
                        return ((Date.parse(left)).valueOf() < (Date.parse(firstDay)).valueOf()) ? false : true;
                    }
                },
                methods: {
                    prev: function () {
                        var changeDate = moment([this.calendar.year, this.calendar.month - 1])
                            .subtract(1, 'months');
                        if (changeDate.isSameOrAfter(moment().format('YYYY-MM-DD'), 'month')) {
                            this.calendar.year = changeDate.year();
                            this.calendar.month = changeDate.month() + 1;
                            this.calendar.firstDateDay = changeDate.startOf('month').day();
                            this.calendar.endDate = changeDate.endOf('month').date();
                            fetchInventory.call(this, this.next);
                        } else {
                            alert(text.SystemText.NotFurther);
                        }
                    },
                    next: function () {
                        var changeDate = moment([this.calendar.year, this.calendar.month - 1])
                            .add(1, 'months');
                        this.calendar.year = changeDate.year();
                        this.calendar.month = changeDate.month() + 1;
                        this.calendar.firstDateDay = changeDate.startOf('month').day();
                        this.calendar.endDate = changeDate.endOf('month').date();
                        fetchInventory.call(this, this.prev);
                    },
                    selectRoomQty: function () {
                        this.checkInDate = '';
                        fetchInventory.call(this, function(){});
                    },
                    selectNights: function () {
                        this.checkInDate = '';
                        fetchInventory.call(this, function(){});
                    },
                    selectCheckInDate: function (date, isWaiting, event) {
                        var this$ = $(event.target).closest('a');
                        this$.focus();
                        this.checkInDate = date;
                        this.isWaiting = isWaiting || 0;
                    },
                    backList: function () {
                        window.location = urlPrefix +'/'+ hotelId +'/discount/'+ discountCode ;
                    },
                    submitNext: function(event) {
                        var that = this;
                        if (that.checkInDate instanceof moment) {
                            that.nextLoading = true;
                            let form$ = $('#promotion-submit-form');
                            login.check(function (err, status, userInfo) {
                                if (status === true) {
                                    form$.submit();
                                } else {
                                    that.nextLoading = false;
                                    login.initModal($(event.target), function(target){
                                        that.nextLoading = true;
                                        form$.submit();
                                    }, !!that.isWaiting);
                                }
                            });
                        } else {
                            alert(text.SystemText.SelectDate);
                        }
                    }
                }
            });
        }
    });


    /**一般訂房處理*/
    $(function () {
        $('#change-room').change(function (event) {  //房型庫存頁面切換房型
            window.location = urlPrefix + '/room/'+$("#change-room").val();
        });

        function fetchRoomInventory(cb) {
            let that = this;

            that.isLoading = true;
            that.checkInDate = '';
            $.ajax(urlPrefix + '/discount/roomInventory/' + roomNo, {
                type: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    'year': that.calendar.year,
                    'month': that.calendar.month,
                    'room-qty': that.roomQty,
                    'nights': that.nights,
                    'discount': discountNo
                },
                dataType: 'json',
                success: function(res) {
                    if (true === res.status) {
                        if (true === res.waiting) {
                            that.waiting_on = res.waiting;
                        }
                        let row = that.calendarRow;
                        let inventory = [];
                        let inventoryWeek;
                        for (let i = 0; i <= row; i++) {
                            inventoryWeek = [];
                            for (let j = (7*i); j < (7*(i+1)); j++) {
                                if(j < that.calendar.firstDateDay) {
                                    inventoryWeek.push({
                                        current: false
                                    });
                                } else if (j - that.calendar.firstDateDay >= that.calendar.endDate) {
                                    inventoryWeek.push({
                                        current: false
                                    });
                                } else {
                                    inventoryWeek.push({
                                        date: moment(res.inventory[j - that.calendar.firstDateDay].date),
                                        price: res.inventory[j - that.calendar.firstDateDay].price,
                                        qty: res.inventory[j - that.calendar.firstDateDay].qty,
                                        available: res.inventory[j - that.calendar.firstDateDay].available,
                                        applicable: res.inventory[j - that.calendar.firstDateDay].applicable,
                                        isAfter: moment(res.inventory[j - that.calendar.firstDateDay].date).isSameOrAfter(moment().format('YYYY-MM-DD'), 'day'),
                                        current: true,
                                        discountPrice:res.inventory[j - that.calendar.firstDateDay].discountPrice,
                                        discountExpired:res.inventory[j - that.calendar.firstDateDay].discountExpired
                                    });
                                }
                            }
                            inventory.push(inventoryWeek);
                        }
                        that.inventory = inventory;
                    } else {
                        alert(res.message);
                        cb();
                    }
                    that.isLoading = false;
                }
            });
        }

        if (document.getElementById('vue-discount-room') !== null) {
            let firstDay = moment(firstSaleDay);
            let calendarInitDate = firstDay.isBefore(moment(startDay))? moment(startDay) : firstDay;

            let vm = new Vue({
                el: '#vue-discount-room',
                data: {
                    nights: 1,
                    roomQty: 1,
                    calendar: {
                        firstDay: firstDay,
                        year: calendarInitDate.year(),
                        month: calendarInitDate.month() + 1,
                        firstDateDay: calendarInitDate.startOf('month').day(),
                        endDate: calendarInitDate.endOf('month').date()
                    },
                    waiting_on: false,
                    inventory: [],
                    checkInDate: '',
                    isWaiting: 0,
                    isLoading: false,
                    nextLoading: false
                },
                created: function () {
                    // 先抓取第一個月份的庫存
                    fetchRoomInventory.call(this);
                },
                computed: {
                    startDay: function() {
                        var calendarStart = moment(startDay);
                        if (calendarStart.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')){
                            return calendarStart;
                        } else {
                            return moment([this.calendar.year, this.calendar.month - 1]).startOf('month');
                        }
                    },
                    endDay: function() {
                        var calendarEnd = moment(endDay);
                        if (calendarEnd.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')){
                            return calendarEnd;
                        } else {
                            return moment([this.calendar.year, this.calendar.month - 1]).endOf('month');
                        }
                    },
                    calendarRow: function() {
                        return Math.ceil((this.calendar.endDate + this.calendar.firstDateDay) / 7) - 1;
                    },
                    currentMonth: function() {
                        return this.calendar.firstDay.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month');
                    },
                    checkInDateSend: function() {
                        if (this.checkInDate instanceof moment) {
                            return this.checkInDate.format('YYYY-MM-DD');
                        }
                        return '';
                    },
                    checkNextMonth: function() {
                        var right = (this.calendar.month == 12)
                            ? String(this.calendar.year + 1) + "-01-01"
                            : String(this.calendar.year) + "-" + String(this.calendar.month + 1) +"-01" ;
                        return ((Date.parse(right)).valueOf() > (Date.parse(discountEndDay)).valueOf()) ? false : true;
                    },
                    checkLeftMonth: function() {
                        switch(this.calendar.month) {
                            case 1:
                                var left = String(this.calendar.year - 1) + "-12-31";
                                break;
                            case 2:case 4:case 6:case 8:case 9:
                                var left = String(this.calendar.year) + "-0" + String(this.calendar.month - 1) +"-31";
                                break;
                            case 3:
                                var left = (this.calendar.year % 4 == 0)
                                    ? String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-29"
                                    : String(this.calendar.year) + "-0" + String(this.calendar.month - 1) + "-28";
                                break;
                            case 5:case 7:case 10:
                                var left = String(this.calendar.year) + "-0" + String(this.calendar.month - 1) +"-30";
                                break;
                            case 11:
                                var left = String(this.calendar.year) + "-" + String(this.calendar.month - 1) +"-31";
                                break;
                            case 12:
                                var left = String(this.calendar.year) + "-" + String(this.calendar.month - 1) +"-30";
                                break;
                        }
                        return ((Date.parse(left)).valueOf() < (Date.parse(discountStartDay)).valueOf()) ? false : true;
                    }
                },
                methods: {
                    prev: function () {
                        var changeDate = moment([this.calendar.year, this.calendar.month - 1])
                            .subtract(1, 'months');
                        if (changeDate.isSameOrAfter(moment().format('YYYY-MM-DD'), 'month')) {
                            this.calendar.year = changeDate.year();
                            this.calendar.month = changeDate.month() + 1;
                            this.calendar.firstDateDay = changeDate.startOf('month').day();
                            this.calendar.endDate = changeDate.endOf('month').date();
                            fetchRoomInventory.call(this, this.next);
                        } else {
                            alert(text.SystemText.NotFurther);
                        }
                    },
                    next: function () {
                        let changeDate = moment([this.calendar.year, this.calendar.month - 1])
                            .add(1, 'months');
                        this.calendar.year = changeDate.year();
                        this.calendar.month = changeDate.month() + 1;
                        this.calendar.firstDateDay = changeDate.startOf('month').day();
                        this.calendar.endDate = changeDate.endOf('month').date();
                        fetchRoomInventory.call(this, this.prev);
                    },
                    selectRoomQty: function () {
                        this.checkInDate = '';
                        fetchRoomInventory.call(this, function(){});
                    },
                    selectNights: function () {
                        this.checkInDate = '';
                        fetchRoomInventory.call(this, function(){});
                    },
                    selectCheckInDate: function (date, isWaiting, event) {
                        let this$ = $(event.target).closest('a');
                        this$.focus();
                        this.checkInDate = date;
                        this.isWaiting = isWaiting || 0;
                    },
                    backList: function () {
                        window.location = urlPrefix +'/'+ hotelId +'/discount/'+ discountCode ;
                    },
                    submitNext: function(event) {
                        let that = this;
                        if (that.checkInDate instanceof moment) {
                            that.nextLoading = true;
                            let form$ = $('#room-submit-form');
                            login.check(function (err, status, userInfo) {
                                if (status === true) {
                                    form$.submit();
                                } else {
                                    that.nextLoading = false;
                                    login.initModal($(event.target), function(target){
                                        that.nextLoading = true;
                                        form$.submit();
                                    }, !!that.isWaiting);
                                }
                            });
                        } else {
                            alert(text.SystemText.SelectDate);
                        }
                    }
                }
            });
        }
    });
}

init();


// WEBPACK FOOTER //
// ./webpack/discount/entry.js